import { useState } from "react"
import Modal from "../Modal"
import ProjectBoundryForm from "./ProjectBoundryForm"
import { ApolloError } from "@apollo/client"
interface ProjectBoundryModalProps {
  closeModal: () => void
  onSubmit: () => void
  formData: any
  setFormData: React.Dispatch<React.SetStateAction<any>>
  initialFormData: any
  t: any
  geoCooedinatesError?: ApolloError
  geoCoordinatesLoading?: boolean
}

const EditProjectBoundaryModal = (props: ProjectBoundryModalProps) => {
  const { closeModal, onSubmit, formData, setFormData, t, initialFormData } = props
  const [warning, setWarning] = useState({
    value: true,
    messssage: t("connectSettings.warningMessages.unChangedInput")
  })

  return (
    <Modal
      closeModal={closeModal}
      heading={t("connectSettings.modalHeading")}
      submitButtonText={t("connectSettings.submitButtonText")}
      submitButtonClasses="primary"
      onSubmitButtonClicked={onSubmit}
      submitSpinner={false}
      submitDisabled={warning.value}
      large={true}
    >
      <ProjectBoundryForm
        formData={formData}
        setFormData={setFormData}
        t={t}
        warning={warning}
        setWarning={setWarning}
        initialFormData={initialFormData}
        geoCooedinatesError={props.geoCooedinatesError}
        geoCoordinatesLoading={props.geoCoordinatesLoading}
      />
    </Modal>
  )
}

export default EditProjectBoundaryModal
